// extracted by mini-css-extract-plugin
module.exports = {"balloon":"_7a3fb80146--balloon--_kuxZ","icon":"_7a3fb80146--icon--VZ7AY","route":"_7a3fb80146--route--WMxlZ","route-button":"_7a3fb80146--route-button--b0PYt"};